import HighlightedMultimediaBlock from 'shared/components/mediaItems/HighlightedMultimediaBlock.vue';
import store from 'shared/store';
import { createApp, defineAsyncComponent } from 'vue';

const highlightedMultimediaBlocks = [
	...document.querySelectorAll('[data-highlighted-multimedia]'),
];
if (highlightedMultimediaBlocks) {
	highlightedMultimediaBlocks.forEach((item) => {
		const app = createApp({
			name: 'HighlightedMultimediaBlockApp',
		});
		app.use(store);
		app.component('highlighted-multimedia-block', HighlightedMultimediaBlock);
		app.component(
			'video-poster',
			defineAsyncComponent(
				() =>
					import('shared/components/VideoElements/videoPoster.vue')
			)
		);
		app.mount(item);
	});
}
